import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'LOG',
    name: 'Bishop of Scrolls',
    id: 'BishopOfScrolls',
    health: 50,
    difficulty: 2,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Bishop: Returned',
    id: 'BishopReturned',
    health: 60,
    difficulty: 7,
    expeditionRating: 3,
    additionalInfo: `
      <p>
        Switch the minions in the nemesis deck with the minions you named during the campaign.
        You may name and include more minions to make the game harder.
      </p>
    `,
  },
  {
    expansion: 'LOG',
    name: 'Fate Shepherd',
    id: 'FateShepherd',
    health: 70,
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Griefweaver',
    id: 'Griefweaver',
    health: 60,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
    fightFiveAdditionalInfo: `
    <p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
    <p>Play using Increased Difficulty.</p>
    `,
  },
  {
    expansion: 'LOG',
    name: 'Mist Revealed',
    id: 'MistRevealed',
    health: 80,
    difficulty: 10,
    expeditionRating: 4,
    additionalInfo: `
      <p>
        When playing outside of the legacy campaign, use three random tier 3
        Mist Revealed cards when constructing the nemesis deck.
      </p>
    `,
    fightFiveAdditionalInfo: `
    <p>When playing outside of the legacy campaign, use three random tier 3
        Mist Revealed cards when constructing the nemesis deck.</p>
    <p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
    <p>Play using Increased Difficulty.</p>
    `
  },
  {
    expansion: 'LOG',
    name: 'Mother of Rust',
    id: 'MotherOfRust',
    health: '*',
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Paradox of Bone',
    id: 'ParadoxOfBone',
    health: 80,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Paradox of Myth',
    id: 'ParadoxOfMyth',
    health: 50,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Paradox of Myth and Bone',
    id: 'ParadoxOfMythAndBone',
    health: 40,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: `
      <p>
        Replace the nemesis turn order cards in the turn order deck with
        the Myth and Bone turn order cards.
      </p>
    `,
  },
  {
    expansion: 'LOG',
    name: 'Rust Amalgam',
    id: 'RustAmalgam',
    health: 50,
    difficulty: 6,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Paradox of Bone',
    id: 'ParadoxOfBone',
    health: 80,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
  },
  {
    expansion: 'LOG',
    name: 'Rust Superion',
    id: 'RustSuperion',
    health: 50,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
]
